import React, { useContext } from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import { useMediaQuery } from '@/components/utils/useQueryMedia';
import { useDimensions } from '../utils/useDimensions';

const ContainerDiv = styled.div((props) => props.$styleText);

export const Container = (componentProps) => {
  let props = componentProps;

  const dataElementContext = useContext(DataElementContext);
  let isVisible = true;

  const containerRef = React.useRef(null);
  const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 });
  const isTablet = useMediaQuery(`(min-width: ${window.config.breakpointTablet})`);
  const isDesktop = useMediaQuery(`(min-width: ${window.config.breakpointDesktop})`);
  const breakpoints = React.useMemo(() => ({ isTablet, isDesktop }), [isTablet, isDesktop]);

  [props, isVisible] = processComponentProps(props, dataElementContext, breakpoints);

  React.useEffect(() => {
    if (props.properties?.useDimensions) {
      if (containerRef.current) {
        const observer = new ResizeObserver((entries) => {
          for (let entry of entries) {
            setDimensions({
              width: entry.contentRect.width,
              height: entry.contentRect.height,
            });
          }
        });

        observer.observe(containerRef.current);

        // Cleanup function
        return () => {
          observer.disconnect();
        };
      }
    }
  }, [props.properties?.useDimensions]);

  if (!isVisible) return null;

  let onClick = null;
  if (props.properties && props.properties.onClick && typeof props.properties.onClick === 'function') {
    onClick = props.properties.onClick;
  } else if (
    componentProps.properties &&
    componentProps.properties.onClick &&
    typeof componentProps.properties.onClick === 'function'
  ) {
    onClick = componentProps.properties.onClick;
  }

  const extraDataProps = {};
  if (props?.properties) {
    Object.keys(props?.properties).forEach((key) => {
      if (key.indexOf('data-') === 0) {
        extraDataProps[key] = props?.properties[key];
      }
    });
  }

  if (props?.properties?.key) {
    extraDataProps['key'] = props?.properties?.key;
  }

  if (props?.properties?.title) {
    extraDataProps['title'] = props?.properties?.title;
  }

  let style = props.style;
  if (props?.properties?.useDimensions) {
    style = { ...(style ?? {}), '--container-width': dimensions.width, '--container-height': dimensions.height };
  }

  return (
    <ContainerDiv
      ref={containerRef}
      className={props.className ?? ''}
      $styleText={props.styleText}
      onClick={onClick}
      style={style}
      id={props?.properties?.id}
      data-node-id={props.nodeId}
      {...extraDataProps}
    >
      {componentProps.children}
    </ContainerDiv>
  );
};
